/// <amd-module name="Repos/Tfvc/Views/ChangeDetails/Components/ChangeTabContent" />
import * as React from "react";
import { IPerformanceScenarioPendingWork, PerformanceScenarioContext } from "VSS/Platform/Components/Performance";
import { TabContent } from "VSSUI/Tabs";
import { useChangeDetailsContext } from "../ChangeDetailsContext";

export const ChangeDetailsTabContent = (): JSX.Element => {
    let pendingWork: IPerformanceScenarioPendingWork | undefined;

    const { perfContext } = useChangeDetailsContext();

    React.useEffect(() => {
        // Register and complete pending work before rendering a tab through
        // its component did mount/update.
        if (pendingWork) {
            pendingWork.complete();
        }
    });

    return (
        <PerformanceScenarioContext.Consumer>
            {scenarioProps => {
                pendingWork = scenarioProps.registerPendingWork(perfContext.pendingWorkName);
                return <TabContent />;
            }}
        </PerformanceScenarioContext.Consumer>
    );
};
